const routes = {
  shifts: 'Arbeitszeit',
  passengers: 'Mitarbeiter'
};

export default routes;
